import React from 'react';

interface FeaturedVideoProps {
  videoRef?: React.RefObject<HTMLVideoElement>;
  poster?: string;
  src?: string;
  title?: string;
}

const ExpertsBlockFeaturedVideo = ({ videoRef, poster, src, title }: FeaturedVideoProps) => (
  <>
    <h2 className="text-center font-suisse-neue text-body-md sm:text-subheadline-sm">{title}</h2>
    <div className="aspect-[16/9] w-full">
      <video
        ref={videoRef}
        className="h-full w-full"
        poster={poster}
        preload="metadata"
        src={src}
        controls
        playsInline
      />
    </div>
  </>
);

export default ExpertsBlockFeaturedVideo;
